<template>
  <Dialog
    modal
    header="Contas Fixas"
    @update:visible="$emit('update:visible', false)"
    style="background-color: transparent; border: none; box-shadow: none"
  >
    <template #container>
      <div class="flex flex-column align-items-center">
        <ProgressSpinner class="spinner" strokeWidth="8" fill="transparent" animationDuration=".5s" />
        <span class="loading-text" v-html="loadingMessage"></span>
      </div>
    </template>
  </Dialog>
</template>
<script setup>
import { useLoading } from "@/components/composables/useLoading";
const { loadingMessage } = useLoading();
defineEmits(["update:visible"]);
</script>
<style scoped>
.loading-text {
  color: white;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
  text-shadow: 1px 1px 2px black, -1px -1px 2px black, 1px -1px 2px black, -1px 1px 2px black;
}
.spinner {
  width: 60px;
  height: 50px;
}
</style>
